import React from 'react';

const OtherTab = ({ register }) => {
  return (
    <div>
      <div className="col-span-3">
        <label className="block text-sm font-medium text-gray-700">Notes</label>
        <textarea
          {...register('notes')}
          rows={6}
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
          placeholder="Enter any additional notes or information..."
        />
      </div>
    </div>
  );
};

export default OtherTab; 